import endPoints from 'utils/endPoints';
import { FetchAllData } from 'utils/mutationAndQuery/customUseQuery';

export const fetchAllBusinessTypes = () => {
  const { data, isLoading, isSuccess } = FetchAllData({
    url: endPoints.fetchBusinessType,
  });
  return {
    isLoading,
    businessTypes: data?.data ?? [],
    message: data?.message,
    isSuccess,
  };
};

export const fetchAllCountry = () => {
  const { data, isLoading, isSuccess } = FetchAllData({
    url: endPoints.countries,
  });
  return {
    isLoading,
    countries: data?.data ?? [],
    message: data?.message,
    isSuccess,
  };
};



export const fetchAllPermission = () => {
  const { data, isLoading, isSuccess } = FetchAllData({
    url: endPoints.userPermissions
  });
  return {
    isLoading,
    permission: data?.data ?? [],
    message: data?.message,
    isSuccess,
  };
};
